import React from 'react';
import classNames from 'classnames';

interface IEventLineProps {
  /** ref 引用 */
  lineRef: React.RefObject<HTMLDivElement>;

  /** 是否高亮 */
  highlight?: boolean;

  /** 趋势方向 */
  trend?: 'up' | 'down' | 'mixed';

  /** 是否选中 */
  selected?: boolean;

  /** 是否灰色淡化 */
  dimmed?: boolean;

  /** 是否使用灰色样式（与 MarkArea 保持一致） */
  neutral?: boolean;
}

export function EventLine({
  lineRef,
  highlight,
  trend,
  selected,
  dimmed,
  neutral = false,
}: IEventLineProps) {
  return (
    <div
      ref={lineRef}
      className={classNames('dbo-hp-event-box-line', {
        '--highlight': highlight,
        '--down': !neutral && trend === 'down',
        '--up': !neutral && (trend === 'up' || !trend),
        '--selected': selected,
        '--dimmed': dimmed,
        '--neutral': neutral,
      })}
    />
  );
}
